const cashierService = function () {
  const service = this

  service.configCashier = {}

  let execAfterRegister = false
  service.updateComponent = () => {
    execAfterRegister = true
  }

  service.setCashier = (setting) => {
    service.configCashier = setting
    service.updateComponent()
  }

  service.updateCashier = (setting) => {
    service.configCashier = setting
    if (execAfterRegister) {
      const tryExecute = () => {
        if (service.startFunction) {
          service.startFunction()
          service.updateComponent()
        } else {
          setTimeout(() => tryExecute(), 1000)
        }
      }
      tryExecute()
    }
    service.updateComponent()
  }

  service.registerCashier = (setting) => {
    service.startFunction = setting
    if (execAfterRegister === true) {
      service.startFunction()
    }
    service.updateComponent()
  }

  return service
}

export default cashierService



// WEBPACK FOOTER //
// ./src/modules/topbar/components/cashier/service/cashier.service.js